import * as actions from '../actions/advertisingOptionsActions';
import { VendorList, Vendor } from 'consent-string';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ControlIcons } from 'owa-control-icons';
import OptionDescription from 'owa-options-controls/lib/components/OptionDescription';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
const styles = require('./AdvertisingOptionFull.scss');
const className = require('classnames/bind').bind(styles);

export interface AdvertisingOptionGdprPartnerListViewProps {
    vendorList: VendorList;
}

@observer
export default class AdvertisingOptionGdprPartnerListView extends React.Component<
    AdvertisingOptionGdprPartnerListViewProps,
    {}
> {
    private switchToGdprChoiceView = (evt: React.MouseEvent<EventTarget> | KeyboardEvent) => {
        actions.switchView(false);
    };

    render() {
        const linkNAI = 'https://optout.networkadvertising.org/?c=1#!/';
        const linkDAA = 'https://optout.aboutads.info/?c=2#!/';
        const linkEDAA = 'https://youronlinechoices.eu/';
        const linkPrivaryDashboard = 'https://account.microsoft.com/privacy/ad-settings/';

        return (
            <div>
                <CommandButton
                    className={styles.backToPrevious}
                    onClick={this.switchToGdprChoiceView}
                    iconProps={{
                        iconName: ControlIcons.ChevronLeft,
                        styles: {
                            root: className(styles.icon, 'flipForRtl'),
                        },
                    }}
                    text={strings.option_ads_button_goback_list}
                />
                <div className={styles.container}>
                    <section>
                        <OptionDescription>
                            {strings.option_ads_description_completelist_brief_intro}
                        </OptionDescription>
                        {/* tslint:disable:react-no-dangerous-html */}
                        {/* VSO:18675 -- get rid of the need for dangerouslySetInnerHTML */}
                        <OptionDescription>
                            {
                                <span
                                    className={styles.description}
                                    dangerouslySetInnerHTML={{
                                        __html: format(
                                            strings.option_ads_description_completelist_action_intro,
                                            linkNAI,
                                            linkDAA,
                                            linkEDAA
                                        ),
                                    }}
                                />
                            }
                        </OptionDescription>
                        <OptionDescription>
                            {
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: format(
                                            strings.option_ads_description_completelist_manage_intro,
                                            linkPrivaryDashboard
                                        ),
                                    }}
                                />
                            }
                        </OptionDescription>
                        {/* tslint:disable:react-no-dangerous-html */}
                    </section>

                    <section>
                        <header className={styles.title}>
                            {strings.option_ads_header_completelist_partner_list}
                        </header>
                        {this.props.vendorList && (
                            <div>{this.renderVendorList(this.props.vendorList)}</div>
                        )}
                    </section>
                </div>
            </div>
        );
    }

    private renderVendorList(vendorList: VendorList): JSX.Element {
        let rows: JSX.Element[] = [];

        // Sort the vendor list collection
        let sortedVendorListCollection = vendorList.vendors.sort(function(
            left: Vendor,
            right: Vendor
        ) {
            let leftVendorName: string = left.name;
            let rightVendorName: string = right.name;
            return leftVendorName < rightVendorName ? -1 : leftVendorName > rightVendorName ? 1 : 0;
        });

        sortedVendorListCollection.forEach(vendor => {
            rows.push(
                <div key={vendor.name}>
                    <Link href={vendor.policyUrl} target="_blank">
                        {vendor.name}
                        <IconButton
                            className={styles.icon}
                            iconProps={{
                                iconName: ControlIcons.OpenInNewWindow,
                            }}
                        />
                    </Link>
                </div>
            );
        });

        return <div>{rows}</div>;
    }
}
